export const A_TICKETS_SEARCH = "A_TICKETS_SEARCH";
export const A_CHANGE_RESULT_CURRENCY = "A_CHANGE_RESULT_CURRENCY";
export const A_CHANGE_SECOND_FILTER = "A_CHANGE_SECOND_FILTER";
export const A_SET_SEARCH_SECOND_PARAMS = "A_SET_SEARCH_SECOND_PARAMS";
export const A_SET_DATE = "A_SET_DATE";
export const A_SET_DIRECT = "A_SET_DIRECT";
export const A_CHANGE_TARIFF = "A_CHANGE_TARIFF";
export const A_SET_API_URL = "A_SET_API_URL";
export const A_SET_API_ORIGIN = "A_SET_API_ORIGIN";
export const A_GET_VARIANTS = "A_GET_VARIANTS";
